import store from '@/stores'
import { Message } from 'element-ui'

/**
 * 吐司提示
 * 支持：success, info, warn, error, loading 三种提示类型
 */
export default {
  /**
   * 成功
   *
   * @param {string} message 消息内容
   */
  success(message) {
    this._updateToast(message, 'success')
  },

  /**
   * 提示
   *
   * @param {string} message 消息内容
   */
  info(message) {
    this._updateToast(message, 'info')
  },

  /**
   * 警告
   *
   * @param {string} message 消息内容
   */
  warn(message) {
    this._updateToast(message, 'warn')
  },

  /**
   * 错误
   *
   * @param {string} message 消息内容
   */
  error(message) {
    console.error(message)
    this._updateToast(message, 'error')
  },

  /**
   * 加载中
   *
   * @param {string} message 消息内容
   */
  loading(message) {
    this._updateToast(message, 'loading')
  },

  /**
   * 关闭提示
   */
  close() {
    const cleanToast = { message: '', type: '', timer: undefined }
    store.dispatch('app/updateToast', cleanToast)
  },

  /**
   * 更新最新的 toast 的信息。
   * 显示的地方，直接通过 this.$store.state.app.toast 获取信息后显示
   *
   * @param {string} message 消息
   * @param {string} type 支持 success/info/warn/error/loading
   * @param {number} timeout 消息显示的时长
   */
  _updateToast(message, type = 'success', timeout = 10000) {
    // 忽略没有定义的错误
    if (message === '') {
      return
    }

    const toast = store.state.app.toast

    // 取消上一次的清理计时器，避免错误清理本次提示的信息
    if (toast.timer != undefined) {
      clearTimeout(toast.timer)
    }

    // N 毫秒后，清空 toast 的信息
    const timer = setTimeout(() => {
      const cleanToast = { message: '', type: '', timer: undefined }
      store.dispatch('app/updateToast', cleanToast)
      Message.closeAll()
    }, timeout)

    // 更新 toast 的信息
    const newToast = { message: message, type: type, timer: timer }
    store.dispatch('app/updateToast', newToast)
    Message.closeAll()
    Message({
      showClose: true,
      message: message,
      type: type,
      duration: 0
    })
  }
}
